<script lang="ts">
	import CollectionsMenuItem from './CollectionsMenuItem.svelte';
	import TagPopover from './TagsPopover.svelte';
	import { getHubStores } from '$lib/stores/hubStores';
	import { isSideBarOpen } from '../stores';

	import { _ } from 'svelte-i18n';

	const { collections } = getHubStores();
</script>

<div class="wrapper">
	<div class="innerWrapper">
		{#each $collections as collection}
			{#if collection.tags && collection.tags.length}
				<TagPopover {collection}>
					<CollectionsMenuItem {collection} />
				</TagPopover>
			{:else}
				<CollectionsMenuItem {collection} />
			{/if}
		{/each}
	</div>
	<button type="button" class="more" on:click={() => ($isSideBarOpen = true)}>
		{$_('hubs.post.accessibility.more.collections')}
	</button>
</div>

<style>
	.wrapper {
		display: flex;
		align-items: center;
		block-size: 100%;
		inline-size: 100%;
	}

	.innerWrapper {
		display: flex;
		flex-wrap: wrap;
		align-items: center;
		justify-content: center;
		block-size: 40px;
		inline-size: 100%;
		overflow: hidden;
		gap: var(--gutterDefault);
	}

	.more {
		all: unset;
		inline-size: 150px;
		margin-inline-start: var(--gutterDefault);
		opacity: 0.9;
		font-size: var(--fontSizeSmallest);
		text-transform: uppercase;
		cursor: pointer;
		border-block-end: solid 2px transparent;
	}

	.more:hover {
		opacity: 1;
	}

	.more:focus {
		outline: -webkit-focus-ring-color auto 1px;
	}
</style>
